export default __webpack_public_path__ + "media/739f3e4fe750fc01d0bc966ee90684d5da34132d526433eeb7c1e16425c7e0f8.svg";